export default function () {
  return {
    poizon_page_pageview(platfrom) {
      if (platfrom !== 'sensors') return
      // eslint-disable-next-line camelcase
      return {
        current_page: 718,
        current_page_title: document.title,
      }
    },
  }
}
